import { Switch, Route, useHistory } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import SignUpPage from "../pages/SignUpPage";
import PopUpContextProvider from "../services/context/popupContext";
import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useSocket from "../services/utils/custom hooks/Notifications/useSocket";
import useSocketSubscribe from "../services/utils/custom hooks/Notifications/useSocketSubscribe";
import AdminRoutes from "./AdminRoutes";
import ForgetPasswordPage from "../pages/ForgetPasswordPage";
import VerifyEmail from "../pages/VerifyEmailPage";
import { useEffect } from "react";
import NoConnectionPage from "../pages/NoConnectionPage";
import AccessDenied from "../pages/AccessDeniedPage";
import { AdminProvider } from "../services/context/TourPopupContext";
import FeatureFlagProvider from "../services/context/FeatureFlaggingContext";
import OktaConfig from "../config/oktaConfig";
import RedirectLoginRoute from "../pages/Auth/RedirectLoginRoute";
import useAdBlockDetector from "../components/global/DetectAdBlock";
import toastMessages from "../services/utils/helpers/toastMessage";
import JiraWidget from "../components/global/JiraWidget";
import LogoutStatusPopup from "../components/global/LogoutStatusPopup";
import NotFoundPage from "../pages/NotFoundPage";
import { clearMfaSoftPromptDismissal } from "../services/utils/helpers/mfaHelpers";

const oktaAuth = new OktaAuth(OktaConfig.oktaAuthConfig);
function AdminRoutesWithProvider() {
  return <AdminRoutes />;
}

function AppRoutes() {
  const history = useHistory();
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    clearMfaSoftPromptDismissal();
    history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };
  const socket = useSocket(oktaAuth?.getAccessToken());
  useSocketSubscribe(socket);
  const AdBlockerEnabled = useAdBlockDetector();

  useEffect(() => {
    if (AdBlockerEnabled) {
      toastMessages.warning(
        "Ad Blocker Detected. Please disable your ad blocker to use all features of the application"
      );
    }
  }, [AdBlockerEnabled]);

  useEffect(() => {
    window.addEventListener("offline", () => {
      history.replace("/offline");
    });
    window.addEventListener("online", () => history.push("/access/dashboard"));
  }, []);

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <AdminProvider>
        <PopUpContextProvider>
          <FeatureFlagProvider>
            <Switch>
              <Route exact path={"/"} component={LandingPage} />
              <Route exact path={"/login"} component={RedirectLoginRoute} />
              <Route path={"/signup"} component={SignUpPage} />
              <Route path="/forget-password" component={ForgetPasswordPage} />
              <Route path={"/verify-email"} component={VerifyEmail} />
              <Route path={"/offline"} component={NoConnectionPage} />
              <Route path="/access" component={AdminRoutesWithProvider} />
              <Route path="/login/callback" component={LoginCallback} />
              <Route path={"/unauthorized"} component={AccessDenied} />
              <Route component={NotFoundPage} />
            </Switch>
          </FeatureFlagProvider>

          <ToastContainer style={{ zIndex: "99999" }} />
          <JiraWidget />
          <LogoutStatusPopup />
        </PopUpContextProvider>
      </AdminProvider>
    </Security>
  );
}

export default AppRoutes;
